import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_TerminationChangeSummary = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_TerminationChangeSummary' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Service Termination/ Change Summary</h3></p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name</span></td>
                        <td className='w-250'><span className='eleHeader'>ID Number</span></td>
                        <td className='w-250'><span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdNumber' name='txtIdNumber' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtServiceDate' name='txtServiceDate' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceTermination' name='cbServiceTermination' className='add-only' value='ServiceTermination' /> Service Termination
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceChange' name='cbServiceChange' className='add-only' value='ServiceChange' /> Service Change
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Effective Date of Service Change/Termination:</span>
                    <input type='text' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Service Termination or Change is expected to be</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceTermination_1' name='cbServiceTermination_1' className='add-only' value='ServiceTermination_1' /> Temporary
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceTermination_2' name='cbServiceTermination_2' className='add-only' value='ServiceTermination_2' /> Permanent
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reasons for Service Termination/Change</span>
                            <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-220'>
                            <input type='checkbox' id='cbReasonsTermination_1' name='cbReasonsTermination_1' className='add-only' value='ReasonsTermination_1' />Change in Diagnosis
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReasonsTermination_2' name='cbReasonsTermination_2' className='add-only' value='ReasonsTermination_2' />Change in Symptoms
                        </td>
                        <td className='w-330'>
                            <input type='checkbox' id='cbReasonsTermination_4' name='cbReasonsTermination_4' className='add-only' value='ReasonsTermination_4' />Change in Treatment Recommendations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-220'>
                            <input type='checkbox' id='cbReasonsTermination_3' name='cbReasonsTermination_3' className='add-only' value='ReasonsTermination_3' />
                            Change in Service Activities</td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbReasonsTermination_5' name='cbReasonsTermination_5' className='add-only' value='ReasonsTermination_5' />
                            Change in Service staff</td>
                        <td className='w-330'>
                            <input type='checkbox' id='cbReasonsTermination_6' name='cbReasonsTermination_6' className='add-only' value='ReasonsTermination_6' />
                            Appropriate for Less Intensive Service</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReasonsTermination_7' name='cbReasonsTermination_7' className='add-only' value='ReasonsTermination_7' /> Other: &nbsp;
                            <input type='text' id='txtReasonsTermination_7' name='txtReasonsTermination_7' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>List Service(s) Discontinued:</span>
                    <textarea id='txtListServiceDiscontinued' name='txtListServiceDiscontinued' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List Service(s) Initiated:</span>
                    <textarea id='txtListServiceInitiated' name='txtListServiceInitiated' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service Change Instructions or Information:</span>
                    <textarea id='txtServiceChangeInstructions' name='txtServiceChangeInstructions' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature/Credentials:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











